import { initialState } from '../state';
import {
  MandatoryNoteVisitedAction,
  MandatoryNoteVisitedActionTypes
} from "@ispm-client/modules/process-executor/store/actions/mandatory-note-visited.actions";

export function mandatoryNoteVisited(state = initialState.mandatoryNotesVisited, action: MandatoryNoteVisitedAction): string[] {
  switch (action.type) {
    case MandatoryNoteVisitedActionTypes.MANDATORY_NOTE_VISITED: {
      const newElementId: string = action.payload.elementId;
      if (state) {
        return (!state.includes(newElementId)) ? [...state, newElementId] : state;
      } else {
        return [newElementId];
      }
    }
    default:
      return state;
  }
}
